import { Button, IconButton } from '@affine/component';
import { CloseIcon } from '@blocksuite/icons/rc';
import type { ReactNode } from 'react';

import * as styles from './follow-invitation-card.css';

/**
 * The card that invites the viewer to follow someone who leads: a moderator, or the assistant
 * at work in the app.
 */
export function FollowInvitationView({
  icon,
  title,
  followLabel,
  onFollow,
  onClose,
  testId = 'follow-invitation-card',
}: {
  icon: ReactNode;
  title: string;
  followLabel: string;
  onFollow: () => void;
  onClose: () => void;
  testId?: string;
}) {
  return (
    <div className={styles.root} data-testid={testId}>
      <div className={styles.iconCol}>
        <div className={styles.iconWrapper}>{icon}</div>
      </div>
      <div className={styles.contentCol}>
        <div className={styles.header}>
          <span className={styles.titleText}>{title}</span>
          <IconButton
            className={styles.closeButton}
            icon={<CloseIcon />}
            onClick={onClose}
            size="16"
          />
        </div>
        <div className={styles.buttonRow}>
          <Button
            variant="primary"
            className={styles.button}
            onClick={onFollow}
          >
            {followLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
